export default "__VITE_ASSET__CgoFOu7W__"